var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLiftiLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1440 380.319"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lifti-logo_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 285.239h1080V0H0Z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#lifti-logo_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 380.319)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-119.527v239.833c0 8.838-7.232 16.07-16.07 16.07-8.437 0-15.668-7.232-15.668-16.07V-13.258c0-8.838 7.231-16.069 15.668-16.069H0a14.403 14.403 0 0 1 14.463 14.463C14.463-6.83 8.035 0 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(151.265 29.327)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-8.437 0-15.669-7.231-15.669-16.069v-253.1c0-8.838 7.232-16.069 15.669-16.069 8.837 0 16.068 7.231 16.068 16.069v253.1C16.068-7.231 8.837 0 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(269.919 285.238)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-168.941c-8.036 0-14.866-6.829-14.866-14.864s6.83-14.463 14.866-14.463h68.399V-269.16c0-8.838 7.232-16.069 16.07-16.069s16.071 7.231 16.071 16.069v239.833H0c8.034 0 14.863 6.428 14.863 14.463S8.034 0 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(824.618 285.238)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-8.437 0-15.669-7.231-15.669-16.069v-253.1c0-8.838 7.232-16.069 15.669-16.069 8.838 0 16.068 7.231 16.068 16.069v253.1C16.068-7.231 8.838 0 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(943.673 285.238)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-148.854c-8.035 0-14.463-6.829-14.463-14.864a14.403 14.403 0 0 1 14.463-14.463H0c8.035 0 14.463 6.83 14.463 14.865A14.403 14.403 0 0 1 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(553.695 285.238)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-98.982c-8.035 0-14.463-6.83-14.463-14.865v-122.532c0-8.838 7.231-16.069 15.668-16.069 8.839 0 16.069 7.231 16.069 16.069v108.07H0c8.035 0 14.463 6.829 14.463 14.865A14.403 14.403 0 0 1 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(503.824 153.467)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-8.764 0-15.868-7.104-15.868-15.868S-8.764-31.736 0-31.736s15.868 7.104 15.868 15.868S8.764 0 0 0",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1064.132 31.737)"
})));
export { SvgLiftiLogo as ReactComponent };